module.exports = __webpack_public_path__ + "ed95b840cf50a2e2df93996980b254be.csv";